<template>
    <el-dialog
            title="添加URl"
            :visible="true"
            width="30%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" :inline="true">
            <el-form-item label="URl:" prop="code">
                <el-input v-model="form.code" clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="confirm('form')">确 定</el-button>
  </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "add-url-dialog",
        data() {
            return {
                form:{
                    code:'',
                },
                rules:{
                    code:[
                        { required: true, message: '请输入url', trigger: 'blur' }
                    ]
                }
            }
        },
        props:{
            spliceUrlArray:{
                type:Array,
                default:[]
            }
        },
        methods: {
            confirm(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.spliceUrlArray.length && this.spliceUrlArray.length > 0){
                            let flag = 0;
                            for( var i = 0; i < this.spliceUrlArray.length;i++){
                                if(this.form.code == this.spliceUrlArray[i]){
                                    this.$message.error('已经存在该设置URl！');
                                    break;
                                }else{
                                    flag++
                                }
                            }
                            if(flag == this.spliceUrlArray.length){
                                this.$emit('pushData',this.form.code);
                                this.$emit('handleClose');
                            }else{
                                this.$message({
                                    message: '已经存在该设置URl',
                                    type: 'warning'
                                });
                            }
                        }else{
                            this.$emit('pushData',this.form.code);
                            this.$emit('handleClose');
                        }

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            handleClose(){
                this.$emit('handleClose');
            }
        },
        created() {
        },
    }
</script>

<style lang="scss" scoped>

</style>